// extracted by mini-css-extract-plugin
export var rating = "starRating-module--rating--3aedb";
export var rating1 = "starRating-module--rating1--3d0d4";
export var rating15 = "starRating-module--rating15--d54ab";
export var rating2 = "starRating-module--rating2--75e1c";
export var rating25 = "starRating-module--rating25--78d0f";
export var rating3 = "starRating-module--rating3--a98ff";
export var rating35 = "starRating-module--rating35--4af54";
export var rating4 = "starRating-module--rating4--dd45a";
export var rating45 = "starRating-module--rating45--055c0";
export var starRating = "starRating-module--starRating--e35fd";